import { render, staticRenderFns } from "./optics.vue?vue&type=template&id=e8592aa8"
import script from "./optics.vue?vue&type=script&lang=js"
export * from "./optics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports